import { JetView } from 'webix-jet';

/**
 * Class representing the view for filtering registered documents.
 * @extends JetView
 */
export default class FilterRegisteredDocumentsView extends JetView {
    /**
     * Configures the layout of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing ID input and document type selection
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Input field for document ID
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('ID'), // Localized placeholder
                },
                {
                    view: 'richselect',
                    name: 'Type', // Dropdown for document type
                    label: _('Tipo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        { id: 'null', value: _('Todos') }, // Option for all types
                        { id: '1', value: _('Documento 1') }, // Option for document type 1
                        { id: '2', value: _('Documento 2') }, // Option for document type 2
                    ],
                },
            ],
        };

        // Center left section containing name input and activation status selection
        const center_left = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Name', // Input field for name
                    label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Localized placeholder
                },
                {
                    view: 'richselect',
                    name: 'IsActivate', // Dropdown for activation status
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        { id: 'null', value: _('Todos') }, // Option for all statuses
                        { id: 'A', value: _('Activado') }, // Option for activated
                        { id: 'I', value: _('Inactivado') }, // Option for deactivated
                    ],
                },
            ],
        };

        // Center right section containing route input
        const center_right = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Route', // Input field for route
                    label: _('Ruta'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Ruta'), // Localized placeholder
                },
            ],
        };

        // Right section containing version input
        const right = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text',
                    name: 'Versión', // Input field for version
                    label: _('Versión'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Versión'), // Localized placeholder
                },
            ],
        };

        // Upper section containing all input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of input sections
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'), // Localized button label for clear
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Localized button label for consult
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Retrieves form values
                        this.app.callEvent('registeredDocuments:filter', [
                            filterdata, // Triggers filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            scroll: 'y', // Enables vertical scrolling
            rows: [upper_section, buttons], // Combines upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
